// Photocopy Machine Icon Web Component
class PhotocopyIcon extends HTMLElement {
  constructor() {
    super();
    this.size = 'medium';
    this.interactive = 'true';
  }

  static get observedAttributes() {
    return ['size', 'interactive'];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this[name] = newValue;
      if (this.isConnected) {
        this.render();
      }
    }
  }

  render() {
    const isInteractive = this.interactive === 'true';
    const sizeClass = `photocopy-${this.size}`;

    this.innerHTML = `
      <div class="photocopy-icon ${sizeClass} ${isInteractive ? 'interactive' : ''}">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Photocopy machine body -->
          <rect x="3" y="8" width="18" height="12" rx="2" fill="currentColor" opacity="0.8"/>
          
          <!-- Paper input tray -->
          <rect x="5" y="6" width="14" height="2" rx="1" fill="currentColor" opacity="0.6"/>
          
          <!-- Control panel -->
          <rect x="6" y="10" width="4" height="2" rx="1" fill="currentColor" opacity="0.4"/>
          
          <!-- Paper output -->
          <rect x="4" y="20" width="16" height="1" rx="0.5" fill="currentColor" opacity="0.6"/>
          
          <!-- Copy indicator -->
          <circle cx="16" cy="11" r="1" fill="currentColor" opacity="0.9"/>
          
          <!-- Paper being copied -->
          <rect x="8" y="4" width="8" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1" opacity="0.7"/>
          <rect x="9" y="5" width="6" height="1" fill="currentColor" opacity="0.5"/>
          <rect x="9" y="6.5" width="4" height="1" fill="currentColor" opacity="0.5"/>
          <rect x="9" y="8" width="5" height="1" fill="currentColor" opacity="0.5"/>
        </svg>
      </div>
    `;
  }

  // Public method to trigger copy animation
  triggerCopyAnimation() {
    this.classList.add('copying');
    setTimeout(() => {
      this.classList.remove('copying');
    }, 600);
  }

  // Public method to set disabled state
  setDisabled(disabled) {
    if (disabled) {
      this.classList.add('disabled');
    } else {
      this.classList.remove('disabled');
    }
  }
}

// Register the component
customElements.define('photocopy-icon', PhotocopyIcon);

export default PhotocopyIcon;
